import React, { useEffect, useState } from 'react';
import { CheckCircle } from 'lucide-react';
const buyers = [{
  name: 'María',
  city: 'Buenos Aires'
}, {
  name: 'Florencia',
  city: 'Córdoba'
}, {
  name: 'Julieta',
  city: 'Rosario'
}, {
  name: 'Ana',
  city: 'Mendoza'
}, {
  name: 'Sofía',
  city: 'La Plata'
}, {
  name: 'Lucía',
  city: 'Tucumán'
}, {
  name: 'Valentina',
  city: 'Neuquén'
}, {
  name: 'Camila',
  city: 'Mar del Plata'
}];
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [buyer, setBuyer] = useState(buyers[0]);
  useEffect(() => {
    // Initial delay
    const initialTimeout = setTimeout(() => {
      showPopup();
    }, 5000);
    const showPopup = () => {
      // Pick random buyer
      const randomBuyer = buyers[Math.floor(Math.random() * buyers.length)];
      setBuyer(randomBuyer);
      setVisible(true);
      // Hide after 4 seconds
      setTimeout(() => {
        setVisible(false);
      }, 4000);
      // Schedule next popup (random between 15-20s)
      const nextDelay = Math.floor(Math.random() * 5000) + 15000;
      setTimeout(showPopup, nextDelay);
    };
    return () => clearTimeout(initialTimeout);
  }, []);
  if (!visible) return null;
  return <div className="fixed bottom-4 left-4 z-50 animate-slide-up" data-id="element-221">
      <div className="bg-white rounded-lg shadow-lg p-4 flex items-center gap-4 border-l-4 border-green-500 max-w-xs" data-id="element-222">
        <div className="bg-green-100 p-2 rounded-full" data-id="element-223">
          <CheckCircle className="w-6 h-6 text-green-600" data-id="element-224" />
        </div>
        <div data-id="element-225">
          <p className="text-sm font-bold text-gray-900" data-id="element-226">
            {buyer.name} de {buyer.city}
          </p>
          <p className="text-xs text-gray-600" data-id="element-227">acaba de comprar el MegaPack</p>
          <p className="text-[10px] text-gray-400 mt-1" data-id="element-228">Hace unos instantes</p>
        </div>
      </div>
    </div>;
}